class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();

    this.querySelector('a').addEventListener('click', (event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);


class CartInvoice extends HTMLElement {
  constructor() {
    super();

    const btn = $(this).find('button');

    function isValidEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    }

    btn.on('click', async (event) => {
      event.preventDefault();
      const btn = $(this);
      const fattura = document.getElementById("richiediFattura");
      const pIVA = document.getElementById("partitaIVA");

      var codiceSDI = document.getElementById("codiceSDI");
      var codicePEC = document.getElementById("codicePEC");
      const obj = {}
      if (fattura.checked) {
        obj['attributes'] = {}
        obj['attributes']["fattura"] = true
        if (pIVA.value && pIVA.value !== '' && codiceSDI.value && codiceSDI.value !== '' && codicePEC.value && isValidEmail(codicePEC.value)) {
          obj['attributes']["piva"] = pIVA.value
          obj['attributes']["sdi"] = codiceSDI.value
          obj['attributes']["pec"] = codicePEC.value
          const body = JSON.stringify(obj);
          await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        } else {
          if (pIVA.value === '') {
            pIVA.style.border = "1px solid red";
          } else {

            pIVA.style.border = "1px solid #c7c7c7";
          }
          if (codiceSDI.value === '') {
            codiceSDI.style.border = "1px solid red";
          } else {
            codiceSDI.style.border = "1px solid #c7c7c7";
          }
          if (!isValidEmail(codicePEC.value)) {
            codicePEC.style.border = "1px solid red";
          } else {
            codicePEC.style.border = "1px solid #c7c7c7";
          }

          return false;
        }

      }

      window.location = btn.attr("data-href");
    })
  }
}

customElements.define('cart-invoice', CartInvoice);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')) {
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
        .then((response) => response.text())
        .then((responseText) => {

        });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);